import { useEffect, useState } from 'react'
import { Loader2, Check, AlertTriangle } from 'lucide-react'
import type { SaveStatus } from '@/hooks/saveStatus'
import { cn } from '@/lib/utils'

export function SaveIndicator({ status }: { status: SaveStatus }) {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (status === 'saving' || status === 'error') {
            setVisible(true)
            return
        }
        if (status === 'saved') {
            setVisible(true)
            const t = setTimeout(() => setVisible(false), 3000)
            return () => clearTimeout(t)
        }
    }, [status])

    if (!visible) return null

    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 text-xs font-medium',
                status === 'saving' && 'text-muted-foreground',
                status === 'saved' && 'text-[color-mix(in_oklch,var(--accent-strong),black_25%)] dark:text-accent-strong',
                status === 'error' && 'text-destructive',
            )}
        >
            {status === 'saving' && (<><Loader2 className="size-3.5 animate-spin" /> Saving…</>)}
            {status === 'saved' && (<><Check className="size-3.5" /> Saved</>)}
            {status === 'error' && (<><AlertTriangle className="size-3.5" /> Save failed</>)}
        </span>
    )
}
